import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { createBilderlingspayPayment } from 'modules/payments/bilderlingspay'

const mapDispatchToProps = dispatch => bindActionCreators({ createBilderlingspayPayment }, dispatch)

export default WrappedComponent =>
  connect(null, mapDispatchToProps)(props => <WrappedComponent {...props} />)



// WEBPACK FOOTER //
// ./src/containers/hocs/bilderlingspay.js